// extracted by mini-css-extract-plugin
export var base = "_47-0";
export var updateBanner = "_47-1";